/* unplugin-vue-components disabled */import { render } from "./ExternalContacts.vue?vue&type=template&id=fbde3f72&scoped=true&ts=true"
import script from "./ExternalContacts.vue?vue&type=script&lang=ts"
export * from "./ExternalContacts.vue?vue&type=script&lang=ts"

import "./ExternalContacts.vue?vue&type=style&index=0&id=fbde3f72&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbde3f72"]])

export default __exports__